module.exports = __webpack_public_path__ + "static/bigmart-397d8345b7e9aff87f064deca8695cf0.png";